<span class="shimmer" [style.width]="width"></span>
